import { Store, createStore, applyMiddleware, combineReducers } from "redux"
import { AppState } from "store/store"
import logger from "redux-logger"
import { persistReducer, persistStore } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { compensationStartDateReducer } from "store/states/CompensationStartDateState"
import { cameraOffReducer } from "store/states/CameraOffState"
import { qrReducer } from "./store/states/QRState"
import { userInfoReducer } from "./store/states/UserInfoState"
import { planReducer } from "./store/states/PlanState"
import { uuidReducer } from "./store/states/UUIDState"
import { couponCodeReducer } from "./store/states/CouponCodeState"

// 永続化の設定
const persistConfig = {
  key: "kasya", // Storageに保存されるキー名を指定する
  storage // 保存先としてlocalStorageがここで設定される
  // whitelist: ["todos"] // Stateは`todos`のみStorageに保存する
}
const rootReducer = combineReducers<AppState>({
  qr: qrReducer,
  userInfo: userInfoReducer,
  plan: planReducer,
  uuid: uuidReducer,
  couponCode: couponCodeReducer,
  compensationStartDate: compensationStartDateReducer,
  cameraOff: cameraOffReducer
})
// 永続化設定されたReducerとして定義
const persistedReducer = persistReducer(persistConfig, rootReducer)
// eslint-disable-next-line import/no-mutable-exports
let store: Store<AppState>
if (process.env.NODE_ENV === "production") {
  // 本番環境でredux-loggerを使用しない
  store = createStore(persistedReducer)
} else {
  store = createStore(persistedReducer, applyMiddleware(logger))
}

export const persistor = persistStore(store)
export default store
